import { useMemo, } from 'react'
import { Column } from 'react-table';
import { Card, Modal, Row, Col } from 'react-bootstrap';
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from 'react-i18next';

import { columnsPudLogs } from './columnsPudLogs'
import { useApiClient } from '../../../../../hooks/useApiClient';
import ErrorBoundary from '../../../../ErrorBoundary/ErrorBoundary';
import VehicleTableContainer from '../../../../VehicleTable/VehicleTableContainer';
import useStore from '../../../../../store/TiassistoStore';
import TableSkeleton from '../../../../TableSkeleton/TableSkeleton';
import { useEffect } from "react";


const PudLogs = ({isOpen}) => {
  const { apiClient } = useApiClient();
  const { pudId } = useStore();
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { data: pudLogsdata, isLoading: isPudLogsLoading, error: pudLogsError, isSuccess } = useQuery({
    queryKey: ['PudLogs'],
    queryFn: () => apiClient.tiassistoController.getPudLogs({ pudId }),
    enabled: !!pudId,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });

  const columns = useMemo(() => columnsPudLogs as Column<Object>[], []);
  const data = useMemo(() => pudLogsdata?.data ?? [], [pudLogsdata?.data]);

  const filterIntialState = {
    operator: '',
    created_at: '',
    description: '',
  }

  useEffect(() => {
    return () => {
      if (!isOpen) {
        queryClient.removeQueries({ queryKey: ['PudLogs'] });
      }
    };
  }, [isOpen, queryClient]);

  return (
    <>
      <Modal.Title className='mb-3 mt-4'>
        {t("view_logs_pud")}
      </Modal.Title>

      {isPudLogsLoading ?
          <TableSkeleton cols={5} rows={3} />
          : <></>
          }

      {(!isPudLogsLoading && isSuccess && data.length > 0) ? (
        <Card className="mb-3 shadow-sm p-1">
          <ErrorBoundary>
            <VehicleTableContainer
              columns={columns}
              data={data}
              filterIntialState={filterIntialState}
              hasFilters={false}
              pageSize={5}
              hiddenColumns={['log_id']}
            ></VehicleTableContainer>
          </ErrorBoundary>
        </Card>
      ) : (
        <Card className="mb-3 shadow-sm" >
          <Card.Body>
            <Row>
              <Col>
                <div>{t("no_content_for_pud-logs")}</div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      )}
    </>
  )
}

export default PudLogs;